import { IField } from 'utils/interfaces/IField';
import InputTypes from 'utils/enums/inputTypes';

const sellers: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome do comissionado',
        name: 'name',
        type: InputTypes.text,
        columns: 3
    }
];

export default sellers;
